'use client';

import { BoxCTA } from '@lichtblick/photon/atoms/box-cta/box-cta';
import { Text } from '@lichtblick/photon/atoms/text/text';
import { useTracker } from '@lichtblick/tracker';
import classNames from 'classnames';
import { type FC, useCallback, useEffect, useState } from 'react';
import type { CalculatorEnergySolutionsType } from '../../types/storyblok';
import { CityInput } from '../OAllInOneCalculator/CityInput';
import { useVpCodes } from '../OAllInOneCalculator/useVpCodes';
import styles from './calculator.module.scss';

export const CalculatorEnergySolutions: FC<CalculatorEnergySolutionsType & { className?: string }> = ({
  campaignId,
  ctaText,
  preselectHeatPump,
  preselectPv,
  headline,
  preselectStromWallet,
  preselectWallBox,
  className,
}) => {
  const [postcode, setPostcode] = useState('');
  const [city, setCity] = useState('');

  const { computeVpCodes } = useVpCodes();
  const { trackCustomEvent } = useTracker();

  const cityChangeHandler = useCallback((city: string, postcode: string) => {
    setCity(city);
    setPostcode(postcode);
  }, []);

  const [vpCodes, setVpCodes] = useState<{
    uvp?: string;
    vp?: string;
  }>({});

  useEffect(() => {
    setVpCodes(computeVpCodes());
  }, [computeVpCodes]);

  return (
    <form
      action="/energieloesungen-checkout/"
      className={classNames(styles.form, className)}
      id="energieloesungen-calculator"
      method="GET"
      onSubmit={(e) => {
        if (e.currentTarget.checkValidity()) {
          trackCustomEvent({
            eventName: 'tariff_calculator_show_tariffs',
            customProps: { product: 'Energielösungen', zip_code: postcode },
          });
        }
      }}
    >
      <Text className={classNames(styles.headline, styles.p2h)} renderAs="h4" size="l">
        {headline}
      </Text>
      <div className={styles['input-section']}>
        <CityInput onChange={cityChangeHandler} />

        <input name="ort" type="hidden" value={city} />
        <input name="plz" type="hidden" value={postcode} />
        {Boolean(campaignId) && <input name="cam" type="hidden" value={campaignId} />}
        {Boolean(vpCodes.vp) && <input name="vp" type="hidden" value={vpCodes.vp} />}
        {Boolean(vpCodes.uvp) && <input name="uvp" type="hidden" value={vpCodes.uvp} />}
        {preselectPv && <input name="interestInPv" type="hidden" value="true" />}
        {preselectHeatPump && <input name="interestInHeatPump" type="hidden" value="true" />}
        {preselectStromWallet && <input name="interestInStromWallet" type="hidden" value="true" />}
        {preselectWallBox && <input name="interestInWallBox" type="hidden" value="true" />}

        <BoxCTA as="button" type="submit" data-dd-action-name="Calculator Submit: Energy solutions">
          {ctaText || 'Angebot einholen'}
        </BoxCTA>
      </div>
    </form>
  );
};
